module.exports = __webpack_public_path__ + "static/media/pn.96b38d19.jpeg";